import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { newEditPageName } from '../utils/translateUtils';

export const useNewEditPageTranslate = (pageName: string) => {
  const { t } = useTranslation('pages');
  const { id } = useParams();
  return t(newEditPageName(pageName, id));
};
